import React from 'react'
import { MdVolumeOff } from 'react-icons/md'

/**
 * Jab tak browser audio unlock nahi hota, ye patti dikhati hai.
 * Ek tap = saare bells unlock. Unlock hote hi apne aap gayab ho jati hai.
 */
export default function SoundGate({ unlocked, unlock, className = '' }) {
  if (unlocked) return null

  return (
    <button
      type="button"
      onClick={unlock}
      className={`flex w-full items-center justify-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm font-semibold text-amber-800 shadow-sm transition hover:bg-amber-100 active:scale-[0.99] ${className}`}
    >
      <MdVolumeOff className="text-lg shrink-0" />
      Tap to activate sound
    </button>
  )
}